import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";

import AkkhorLayout from "../../layout/AkkhorLayout";
import AlertErrorForm from "../../component/AlertErrorForm";
import SerchBoxMulti from "../../component/SerchBoxMulti";

export default function FormCampaign() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);

    const defaultdetail = {
        author_id: user.data.id,
        title: '',
        alias: '',
        budget: '',
        author_id: user.data.id,
        list_sale:[],
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "campaign/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );

    let validForm = {
        title: Yup.string().trim().nullable().required('Nhập tên chiến dịch').max(250, "Độ dài không quá 250 ký tự"),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];

            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'campaign/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật chiến dịch thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'campaign', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới chiến dịch thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="campaign">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/campaign">Danh sách chiến dịch</Link>
                    </li>
                    <li>{id ? 'Sửa chiến dịch' : 'Thêm mới chiến dịch'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} Chiến dịch</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-12 form-group">
                                <label>Tên chiến dịch <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            <div className="col-12 form-group">
                                <label>Ngân sách</label>
                                <input type="text" placeholder="" className="form-control height32"  {...formik.getFieldProps("budget")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="budget"></AlertErrorForm>
                            </div>
                            <div className="col-12 form-group">
                                <label>Danh sách sale</label>
                                <SerchBoxMulti apiname={"users"} alldata="role_id=3" multiple={true} placeholder="Chọn sale" colvalue={'code'} colname={'fullname'} defaultValue={formik.values['list_sale']} name='list_sale'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('list_sale', e)
                                    }}></SerchBoxMulti>
                            </div>

                            <div className="col-12 form-group">
                                <label>Mô tả ngắn</label>
                                <textarea className="form-control" {...formik.getFieldProps("description")}></textarea>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trạng thái: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("status")}>
                                    <option value="1" >Đang hoạt động</option>
                                    <option value="0" >Ngưng hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu chiến dịch</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
